import { render, staticRenderFns } from "./SettingsTabSessions.vue?vue&type=template&id=12e48ece&"
import script from "./SettingsTabSessions.vue?vue&type=script&lang=js&"
export * from "./SettingsTabSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports